import { Text, SegmentedControl, SegmentedControlProps } from "@mantine/core";

interface Props extends SegmentedControlProps {
  label?: string;
}

export const CustomFieldTypeControl = (props: Partial<Props>) => {
  return (
    <>
      {props.label && (
        <Text size="sm" fw={500} mb={3} mt="sm">
          {props.label}
        </Text>
      )}
      <SegmentedControl
        {...props}
        mt="0"
        data={[
          { label: "Text", value: "t" },
          { label: "Options", value: "o" },
        ]}
      />
    </>
  );
};
